import AsyncStorage from '@react-native-async-storage/async-storage';
import Constants from 'expo-constants';

const PROD_CHATBOT_WS_URL = 'wss://chatbot.hereworks.tech/v1/chat';
const DEV_CHATBOT_WS_URL = 'wss://chatbot-dev2.hereworks.tech/v1/chat';

const DEV_DOMAIN_HINTS = ['dev', 'qa', 'staging', 'localhost'];
const DEV_ENVIRONMENT_HINTS = ['dev', 'demo'];

type ExpoExtraConfig = {
  realtimeChatbotWsUrl?: string;
};

type ExpoManifest = {
  extra?: ExpoExtraConfig;
};

type ExpoManifest2 = {
  extra?: {
    expoClient?: {
      extra?: ExpoExtraConfig;
    };
  };
};

const getRealtimeChatbotWebsocketUrl = async (isDev?: boolean) => {
  if (typeof isDev === 'boolean') {
    return isDev ? DEV_CHATBOT_WS_URL : PROD_CHATBOT_WS_URL;
  }

  const expoConfig = Constants.expoConfig as ExpoManifest | null;
  const manifest = Constants.manifest as ExpoManifest | null;
  const manifest2 = Constants.manifest2 as ExpoManifest2 | null;
  const configUrl = expoConfig?.extra?.realtimeChatbotWsUrl
    ?? manifest2?.extra?.expoClient?.extra?.realtimeChatbotWsUrl
    ?? manifest?.extra?.realtimeChatbotWsUrl;

  if (configUrl?.trim()) {
    return configUrl.trim();
  }

  const explicitRealtimeUrl = await AsyncStorage.getItem('chatbotWebsocketUrl');
  if (explicitRealtimeUrl?.trim()) {
    return explicitRealtimeUrl.trim();
  }

  const environment = (await AsyncStorage.getItem('environment') ?? '').toLowerCase();
  if (DEV_ENVIRONMENT_HINTS.includes(environment)) {
    return DEV_CHATBOT_WS_URL;
  }

  const apiDomain = (await AsyncStorage.getItem('apiDomain') ?? '').toLowerCase();
  const shouldUseDevUrl = DEV_DOMAIN_HINTS.some((hint) => apiDomain.includes(hint));

  return shouldUseDevUrl ? DEV_CHATBOT_WS_URL : PROD_CHATBOT_WS_URL;
};

export { PROD_CHATBOT_WS_URL, DEV_CHATBOT_WS_URL };
export default getRealtimeChatbotWebsocketUrl;
